import { SyntheticEvent } from "react";
import { Box, Grid, Typography } from "@mui/material";
import "../dossier-styles.scss";
import CustomToggleButtonGroup from "../../../UIElements/CustomToggleButtonGroup";
import DownloadBtn from "../../../UIElements/DownloadBtn";
import { DossierHeaderProps } from "./DossierHeader";
import { establishementStatusEnum } from "../../../../types";

export default function SynerpaDossierHeaderContent({
    setActiveTab,
    activeTab,
    tabsMenu,
    headerInfo,
    downloadCertificate,
    downloadAllDoc,
    showDownloadCertificateBtn,
}: DossierHeaderProps) {
    const {
        establishmentName,
        instructorReview,
        assignedValidatorUser,
        assignedComment,
        validatorDecision,
        dossierDetails,
    } = headerInfo;

    const showValidatorDecision =
        validatorDecision?.code !== establishementStatusEnum.CANDIDAT;

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                flexWrap: "wrap",
                gap: "1.5rem",
            }}
        >
            <Grid container spacing={1.5}>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "1.5rem",
                        alignSelf: "stretch",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0.5rem",
                            alignSelf: "stretch",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#023",
                                textAlign: "left",
                                textEdge: "cap",
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                                width: "100%",
                            }}
                        >
                            #{headerInfo.dossierId}
                        </Typography>
                        <Typography
                            sx={{
                                color: "#005499",
                                fontFamily: "Roboto",
                                fontSize: "1.75rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            Dossier de qualification pour l'
                            {headerInfo.referencielName}
                        </Typography>{" "}
                        {/* </Box> */}
                        {establishmentName ? (
                            <Typography
                                sx={{
                                    color: "#023",
                                    fontFamily: "Roboto",
                                    fontSize: "1.25rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "normal",
                                }}
                            >
                                {establishmentName}
                            </Typography>
                        ) : null}
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            // justifyContent: "space-between",
                            gap: "1rem",
                            alignItems: "flex-start",
                            alignSelf: "stretch",
                        }}
                    >
                        {instructorReview ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0.5rem",
                                    alignSelf: "stretch",
                                    flex: "1 0 0",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    Avis instructeur
                                </Typography>
                                <Typography
                                    variant="h1"
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    <b>{instructorReview}</b>
                                </Typography>
                            </Box>
                        ) : null}

                        {assignedComment ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0.5rem",
                                    alignSelf: "stretch",
                                    flex: "1 0 0",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    Commentaire instructeur
                                </Typography>
                                <Typography
                                    variant="h1"
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    <b>{assignedComment}</b>
                                </Typography>
                            </Box>
                        ) : null}
                    </Box>
                    {assignedValidatorUser ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "flex-end",
                                alignItems: "end",
                                alignSelf: "stretch",
                                "@media (max-width:1024px)": {
                                    width: "100%",
                                    //flexDirection: "column",
                                },

                                // justifyContent: "space-between",
                                gap: "1rem",
                                //width: "100%",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0.5rem",
                                    alignSelf: "stretch",
                                    flex: "1 0 0",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    Examen par
                                </Typography>
                                <Typography
                                    variant="h1"
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    <b>
                                        {`${assignedValidatorUser?.firstName} ${assignedValidatorUser?.lastName}`}
                                    </b>
                                </Typography>
                            </Box>

                            {validatorDecision && showValidatorDecision ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                        alignSelf: "stretch",
                                        flex: "1 0 0",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Décision SYNERPA
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>{validatorDecision.label}</b>
                                    </Typography>
                                </Box>
                            ) : null}
                        </Box>
                    ) : null}
                    {/* </Box> */}
                </Grid>
                <Grid
                    xs={12}
                    item
                    sm={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "1.5rem",
                    }}
                >
                    <Box
                        sx={{
                            display: "inline-flex",
                            justifyContent: "flex-end",
                            alignItems: "end",
                            float: "right",
                            minHeight: "unset",
                            gap: "0.5rem",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "flex-end",
                                alignItems: "end",
                                justifyContent: "space-between",
                                marginTop: "1.5rem",
                                "@media (max-width:1024px)": {
                                    width: "100%",
                                },
                            }}
                        >
                            <DownloadBtn
                                label={"documents"}
                                title="Télécharger tous les documents"
                                customsx={{
                                    margin: 0,
                                    float: "right",
                                    marginLeft: "auto",
                                    height: "1.87rem",
                                    padding: "0.5rem 1rem",

                                    "@media (max-width:1024px)": {
                                        width: "100%",
                                        marginTop: 0,
                                    },
                                }}
                                onClick={async () => {
                                    await downloadAllDoc();
                                }}
                            />
                        </Box>

                        {showDownloadCertificateBtn ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "flex-end",
                                    alignItems: "end",

                                    // alignSelf: "stretch",
                                    justifyContent: "space-between",
                                    // margin: 0,
                                    marginTop: "1.5rem",

                                    "@media (max-width:1024px)": {
                                        width: "100%",
                                    },
                                }}
                            >
                                <DownloadBtn
                                    label={"certificat"}
                                    title={"Télécharger le certificat"}
                                    customsx={{
                                        margin: 0,
                                        float: "right",
                                        marginLeft: "auto",
                                        height: "1.87rem",
                                        padding: "0.5rem 1rem",
                                        "@media (max-width:1024px)": {
                                            width: "100%",
                                            marginTop: 0,
                                        },
                                    }}
                                    onClick={async () => {
                                        if (dossierDetails?.id) {
                                            await downloadCertificate(
                                                dossierDetails.id
                                            );
                                        }
                                    }}
                                />
                            </Box>
                        ) : null}
                    </Box>

                    <Box
                        sx={{
                            alignSelf: "flex-end",
                            marginTop: "auto",
                            "@media (max-width:1024px)": {
                                flexDirection: "column",
                                // width: "100%",
                            },
                        }}
                    >
                        <CustomToggleButtonGroup
                            tabsMenu={tabsMenu}
                            active={activeTab}
                            handleChange={(e: SyntheticEvent, value: string) =>
                                setActiveTab(value)
                            }
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
